import { EmployeeOrg } from '../utils/employeeGroup';

export interface OrgBrand {
  headerTitle: string;
  portalLabel: string;
  themeColor: string;
  logoUrl?: string;
}

export const ORG_BRAND: Record<'elink' | 'phishingbox', OrgBrand> = {
  elink: {
    headerTitle: 'eLINK DESIGN',
    portalLabel: 'Employee Portal',
    themeColor: '#143329',
  },
  phishingbox: {
    headerTitle: 'PhishingBox',
    portalLabel: 'Employee Portal',
    themeColor: '#062f4a',
    logoUrl: '/pblogo2x.webp',
  },
};

export function getOrgBrand(group: EmployeeOrg): OrgBrand {
  return group === 'phishingbox' ? ORG_BRAND.phishingbox : ORG_BRAND.elink;
}
